import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { IUserCreate } from "../../../types/user";
import { useRouter } from "../../../routes/hooks";
import { CreateUserService } from "../../../services/users";
import { enqueueSnackbar } from "notistack";
import { IBranch } from "../../../types/branch";
import { useEffect, useState } from "react";
import { IDepartment } from "../../../types/department";
import { useBoolean } from "../../../hooks/use-boolean";
import { AllBranchesService } from "../../../services/branches";
import { AllDepartmentsService } from "../../../services/departments";

const useUserCreate = () => {

    const router = useRouter();
    const loading = useBoolean(true);

    const [branchs, setBranchs] = useState<IBranch[]>([]);
    const [departments, setDepartments] = useState<IDepartment[]>();

    const [selectedBranch, setSelectedBranch] = useState<IBranch | null>(null);
    const [selectedDepartment, setSelectedDepartment] = useState<IDepartment | null>(null);

    const NewUserSchema = Yup.object().shape({
        name: Yup.string().required('Informe o nome do usuário').max(255, 'O nome deve conter no máximo 255 caracteres'),
        username: Yup.string().required('Informe o username do usuário').max(255, 'O username deve conter no máximo 255 caracteres'),
        email: Yup.string().email('Informe um e-mail válido').required('Informe o e-mail do usuário').max(255, 'O e-mail deve conter no máximo 255 caracteres'),
        branch: Yup.object().shape(
            {
                id: Yup.number().required().required('Selecione um departamento'),
                code: Yup.string().required().required('Selecione um departamento'),
                name: Yup.string().required().required('Selecione um departamento')
            }
        ).required("Selecione uma filial"),
        department: Yup.object().shape(
            {
                id: Yup.number().required('Selecione um departamento'),
                name: Yup.string().required('Selecione um departamento'),
            }
        ).required('Selecione um departamento'),
        password: Yup.string().min(6, 'A senha deve conter no mínimo 6 caracteres').required('Informe a senha do usuário').max(255, 'A senha deve conter no máximo 255 caracteres'),
        confirmPassword: Yup.string().oneOf([Yup.ref('password')], 'As senhas não são iguais').required('Confirme a senha do usuário'),
    });

    const methods = useForm({
        resolver: yupResolver<IUserCreate>(NewUserSchema)
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
        setValue
    } = methods;

    const getData = async () => {

        loading.onTrue();

        await AllBranchesService().then(resp => {
            setBranchs(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        await AllDepartmentsService().then(resp => {
            setDepartments(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        loading.onFalse();

    }

    const onSubmit = handleSubmit(async (data: IUserCreate) => {

        await CreateUserService(data).then(resp => {
            enqueueSnackbar(resp.data.message);
            router.push('/users');
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        })

    });

    useEffect(() => {
        getData();
    }, []);

    return {
        isSubmitting,
        onSubmit,
        methods,
        loading,
        branchs,
        departments,
        selectedBranch,
        setSelectedBranch,
        setValue,
        selectedDepartment,
        setSelectedDepartment
    }
}

export default useUserCreate;